import { useContext, useEffect } from "react";
import { TbMoodEmpty } from "react-icons/tb";
import { isEmpty } from "lodash";

import { requestsAdminContext } from "../../../../context/AdminContext/RequestsAdminContext/RequestsAdminContext";
import { genderType } from "../../../../utils";
import PersianNumber from "../../../../utils/PersianNumber/PersianNumber";
import SiteTitle from "../../../../helpers/SiteTitle/SiteTitle";
import MenuUi from "../../../../helpers/MenuUi/MenuUi";

const AdminDashboardRequests = () => {
  const {
    getUsersRequest,
    handleGetUsersRequestAdmin,
    handleChangeUserRequest,
    handleDeleteUserRequest,
  } = useContext(requestsAdminContext);

  useEffect(() => {
    handleGetUsersRequestAdmin();
  }, []);

  //* Table Header
  const tableHeader = [
    { id: 1, title: "#" },
    { id: 2, title: "نام" },
    { id: 3, title: "نام خانوادگی" },
    { id: 4, title: "شماره موبایل" },
    { id: 5, title: "کد ملی" },
    { id: 6, title: "جنسیت" },
    { id: 7, title: "عملیات" },
  ];

  return (
    <>
      <SiteTitle title="درخواست های ورودی" />
      <div className="mr-auto w-full h-screen">
        <div className="flex h-full justify-end items-center rounded-xl bg-mainBackground">
          <div
            className="rounded-xl flex flex-col h-full w-full
              animate__animated animate__fadeIn animate__fast"
          >
            {/* Menu */}
            <MenuUi className={"top-2"} />
            <div className="w-full flex flex-col justify-center items-center mt-10">
              {isEmpty(getUsersRequest) ? (
                <>
                  <span
                    className="mr-auto 2xl:w-[90%] xl:w-[93%] w-full
                py-3 absolute top-[40%] mt-10 text-slate-200 text-xl
                flex flex-col justify-center items-center"
                  >
                    <span>
                      <TbMoodEmpty size={60} className="mb-2" />
                    </span>
                    <p>درخواستی وجود ندارد</p>
                  </span>
                </>
              ) : (
                <>
                  <div className="w-full flex justify-end items-center">
                    <table className="w-full 2xl:w-[95%] xl:w-[93%] lg:w-[90%] h-full">
                      <thead className="text-sm font-medium text-slate-200 border-b-[1px] border-boxColor">
                        <tr>
                          {tableHeader?.map((_item) => (
                            <th key={_item?.id} className="py-3">
                              <div>{_item?.title}</div>
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody className="text-lg divide-y divide-boxColor w-full h-full overflow-y-scroll">
                        {getUsersRequest.map((_item, index) => (
                          <tr
                            key={_item.id}
                            className="hover:bg-boxColor w-full h-16 relative
                            text-center lg:text-sm text-xs font-medium tracking-wide text-slate-200"
                          >
                            {/* Number */}
                            <td className="px-3">{index + 1}</td>
                            {/* First Name */}
                            <td>
                              <span>{_item.firstname}</span>
                            </td>
                            {/* Last Name */}
                            <td>
                              <span>
                                <p>{_item.lastname}</p>
                              </span>
                            </td>
                            {/* Phone Number */}
                            <td>
                              <span>
                                <PersianNumber value={_item.phonenumber} />
                              </span>
                            </td>
                            {/* National Number */}
                            <td>
                              <span>
                                <PersianNumber value={_item.nationalid} />
                              </span>
                            </td>
                            {/* Gender */}
                            <td>
                              <span>{genderType(_item.gender)}</span>
                            </td>
                            {/* Buttons */}
                            <td className="px-3">
                              <span
                                className="flex lg:flex-row-reverse flex-col 
                            justify-center items-center text-gray-950 lg:text-sm
                            text-xs font-bold lg:space-x-2 lg:space-y-0 space-y-2 space-x-0"
                              >
                                {/* Rejection Button */}
                                <span>
                                  <button
                                    onClick={() =>
                                      handleDeleteUserRequest(_item.id)
                                    }
                                    className="bg-red-600 hover:bg-red-700 text-white
                               tracking-wider lg:px-2.5 px-1.5 lg:py-1 py-0.5 rounded-full"
                                  >
                                    رد کردن
                                  </button>
                                </span>
                                {/* Accept Button */}
                                <span>
                                  <button
                                    onClick={() =>
                                      handleChangeUserRequest(_item.id, true)
                                    }
                                    className="bg-green-500 hover:bg-green-600 text-white
                              tracking-wider lg:px-2.5 px-1.5 lg:py-1 py-0.5 rounded-full"
                                  >
                                    قبول کردن
                                  </button>
                                </span>
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminDashboardRequests;
